import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            <div className='bg-[#2D190D] md:px-[60px] px-[20px] md:pt-[60px] pt-[30px] md:pb-[54px] pb-[30px]'>
                <div className="flex md:flex-row flex-col md:gap-0 gap-[20px] justify-between">
                    <div className='max-w-[337px] w-full'>
                        <Link to="/">
                            <img src="/assets/nav/logo.svg" alt="" />
                        </Link>
                        <p className="pt-[30px] pb-[20px] font-[400] font-poppins text-[16px] leading-[26px] text-[#ABABAB]">Gorem ipsum dolor sit amet, consectetur
                            adipiscing elit. Malesuada donec lacus
                            aliquet sit cursus maecenas venenatis.</p>
                        <div className='flex gap-[10px] items-center'>
                            <Link to="/" className='h-[30px] w-[30px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                                <i className="bi bi-instagram text-[#FF6000]"></i>
                            </Link>
                            <Link to="/" className='h-[30px] w-[30px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                                <i className="bi bi-facebook text-[#FF6000]"></i>
                            </Link>
                            <Link to="/" className='h-[30px] w-[30px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                                <i className="bi bi-youtube text-[#FF6000]"></i>
                            </Link>
                            <Link to="/" className='h-[30px] w-[30px] flex justify-center items-center rounded-full bg-[#FFFFFF]'>
                                <i className="bi bi-twitter text-[#FF6000]"></i>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <h6 className="font-[500] font-manrope text-[20px] leading-[26px] text-[#FF6000] capitalize pb-[30px]">menu</h6>
                        <ul className='flex flex-col gap-[22px]'>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Home</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>About us</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Events</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Feeds</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Donation</li>
                        </ul>
                    </div>
                    <div>
                        <h6 className="font-[500] font-manrope text-[20px] leading-[26px] text-[#FF6000] capitalize pb-[30px]">utility pages</h6>
                        <ul className='flex flex-col gap-[22px]'>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Feeds</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Projects</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Gallery</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Contact Us</li>
                            <li className='text-[#ABABAB] font-[500] font-poppins text-[16px] leading-[26px]'>Donation</li>
                        </ul>

                    </div>
                    <div className='border-[1px] max-w-[410px] w-full border-[#A76B7C] bg-[#FFFFFF1C] rounded-[10px] p-[30px]'>
                        <h6 className="font-[500] font-manrope text-[24px] leading-[32px] pb-[5px] text-[#FFFFFF]">Subscribe To Newsletter</h6>
                        <p className="font-[400] text-[16px] font-manrope leading-[24px] text-[#ABABAB] pb-[5px]">Join our subscribers list to get the latest news
                            and special offers</p>
                                <input type="text" placeholder='Enter Your Email Address' className='py-[16px] px-[20px] bg-transparent w-full border border-[#CDCDCD] rounded-[4px] font-[400] text-[16px] font-manrope text-[#B7B6B6] mb-[16px]' />
                                <button style={{background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)"}} className='flex w-full justify-center items-center gap-[6px] py-[15px] rounded-[4px] font-[600] font-manrope text-[16px] leading-[24px] text-[#FFFFFF]'>
                                    Subscribe Now <img src="/assets/nav/share.svg" alt="" />
                                </button>
                    </div>
                </div>
            </div>
            <div className='bg-[#2D190D]'>
            <div className='max-w-[1226px] w-full mx-auto h-[1.5px] bg-[#70707040]'></div>
                <p className="py-[26px] text-center font-[400] font-poppins text-[18px] text-[#ABABAB]">copyright @2023 all right reserved</p>
            </div>
        </>
    )
}

export default Footer